<template>
  <div class="video-container" />
</template>

<script setup lang="ts">
const props = defineProps({
  videoUrl: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['update:view-count']);

useHead({
  script: [{ src: 'https://pic.watv.org/watvplayer/watvPlayer.js?v=1' }],
})


const player = ref<any>(null);
let hasCounted = false;


onMounted(async () => {
  while (!(window as any).WatvPlayer) {
    await new Promise(r => setTimeout(r, 100))
  }
  player.value = new (window as any).WatvPlayer('.video-container', props.videoUrl);
  player.value.addEventListener('timeupdate', onTimeUpdate);
  player.value.addEventListener('finished', onFinished);
})

onUnmounted(() => {
  player.value.destroy()
})

function onTimeUpdate(event: any) {
  const duration = event.target.duration;
  const currentTime = event.target.currentTime;
  if (!hasCounted && duration > 0 && currentTime / duration >= 0.5) {
    hasCounted = true;
    console.log('[50% 이상 시청]')
    emit('update:view-count');
  }
}

function onFinished(event: any) {
  console.log('[재생 종료]')
  hasCounted = false;
}

</script>